'use client';

import React from 'react';
import { domMax, LazyMotion, MotionConfig } from 'motion/react';

/**
 * Loads Motion's DOM features once for the whole app (components use the lightweight `m.*`
 * elements), including layout animations for the nav marker and filtered grids, and turns
 * movement off for people who ask their OS for reduced motion.
 */
export default function MotionProvider({ children }: { children: React.ReactNode }) {
  return (
    <LazyMotion features={domMax}>
      <MotionConfig reducedMotion='user'>{children}</MotionConfig>
    </LazyMotion>
  );
}
